import { render } from "./AppointmentsPage.vue?vue&type=template&id=29616bb0&ts=true"
import script from "./AppointmentsPage.vue?vue&type=script&lang=ts"
export * from "./AppointmentsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__